import { useFeatureFlags } from 'utils/features';

export default function useEquipmentMaintenanceIsEnabled(): boolean {
  return useFeatureFlags('EQUIPMENT_MAINTENANCE');
}
